import React from 'react'
import styled, { injectGlobal } from 'styled-components'
import Link from 'gatsby-link'
import MediaQuery from 'react-responsive'
import Social from '../components/social'
import { mobile, desktop, tablet } from '../utils/media'

injectGlobal`
  @font-face {
      font-family: "butlerregular";
      src: url(${require("../fonts/butler_regular-webfont.woff2")}) format("woff2");
      font-weight: normal;
      font-style: normal;
  }

  html { box-sizing: border-box; }
  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }
  html,
  body {
    margin: 0;
    padding: 0;
  }
  html { min-height: 100%; }
  body {
    color: white;
    font-family: 'Quattrocento Sans', serif;
    background: black;
  }

  a {
    color: inherit;
    text-decoration: none;
  }
`

const AppContainer = styled.div`
  width: 100%;
`

const MobileLink = styled(Link)`
  z-index: 1000;
  position: fixed;
  bottom: 0;
  padding: 10px 0;
  width: 50%;
  color: white;
  text-align: center;
  font-size: 16px;
  letter-spacing: 6px;
  text-transform: uppercase;
  background: black;
  opacity: .8;

  ${desktop`
    display: none;
  `}
`

const StyledLinkWrapper = styled.div`
  display: none;

  @media (min-width: 1200px) {
    cursor: pointer;
    z-index: 1000;
    position: fixed;
    top: 35%;
    left: 1%;
    display: block;
    font-family: 'Quattrocento Sans';
    text-align: center;
    font-size: 16px;
    letter-spacing: 6px;
    text-transform: uppercase;
    text-decoration: none;
    transform-origin: 0 100%;
    transition: all 0.5s;

    top: ${props => (
      props.path === '/en/about/' || props.path === '/ru/about/'
        ? 'calc(35% - 50px)' : '35%'
    )};
    left: ${props => (
      props.path === '/en/about/' || props.path === '/ru/about/'
        ? '50px' : '1%'
    )};
    padding: ${props => (
      props.path === '/en/about/' || props.path === '/ru/about/'
        ? '40px 0 0 0' : '0'
    )};
    width: ${props => (
      props.path === '/en/about/' || props.path === '/ru/about/'
        ? '50px' : 'auto'
    )};
    height: ${props => (
      props.path === '/en/about/' || props.path === '/ru/about/'
        ? '170px' : 'auto'
    )};
    transform: ${props => (
      props.path === '/en/about/' || props.path === '/ru/about/'
        ? 'rotate(90deg)' : 'none'
    )};
  }
`

const StyledLink = styled(Link)`
  color: #fff;
  text-decoration: none;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
`

const Back = styled(Link)`
  z-index: 1000;
  position: fixed;
  top: 33.7%;
  left: 1%;
  margin: 0;
  padding: 0;
  width: 0;
  color: #fff;
  font-family: 'Quattrocento Sans';
  text-align: center;
  font-size: 16px;
  letter-spacing: 6px;
  text-transform: uppercase;
  text-decoration: none;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  cursor: pointer;
  transition: all 0.5s;
`

class Template extends React.Component {
  render() {
    const { location, children } = this.props
    const link = location.pathname === '/en/about/' ||
      location.pathname === '/ru/about/'
        ? '/' : '/en/about/'
    const text = location.pathname === '/en/about/' ||
      location.pathname === '/ru/about/'
        ? 'Back' : 'About'

    let header
    if (location.pathname === '/') {
      header = (
        <h1>
          <Link to={'/'} >
            Gatsby Starter Blog
          </Link>
        </h1>
      )
    } else {
      header = (
        <h3>
          <Link to={'/'}>
            Gatsby Starter Blog
          </Link>
        </h3>
      )
    }

    return (
      <AppContainer>
        {
          location.pathname === '/'
            ? <MobileLink to="/en/about/">About</MobileLink>
            : <MobileLink to="/">Back</MobileLink>
        }
        {
          location.pathname === '/en/about/' ||
          location.pathname === '/ru/about/' ||
          location.pathname === '/'
            ? (
              <StyledLinkWrapper>
                <StyledLink to={link}>{text}</StyledLink>
              </StyledLinkWrapper>
            ) : (
              <StyledLinkWrapper>
                <StyledLink to="/">{"Back"}</StyledLink>
              </StyledLinkWrapper>
            )
        }
        {
          location.pathname === '/en/about/' ||
          location.pathname === '/ru/about/' ||
          location.pathname === '/'
            ? <Social />
            : null
        }
        {children()}
      </AppContainer>
    )
  }
}

Template.propTypes = {
  children: React.PropTypes.func,
  location: React.PropTypes.object,
  route: React.PropTypes.object,
}

export default Template



// WEBPACK FOOTER //
// ./src/layouts/index.js